import { render, staticRenderFns } from "./planSimulator.vue?vue&type=template&id=4224950f&"
import script from "./planSimulator.vue?vue&type=script&lang=js&"
export * from "./planSimulator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports